import '../App.css'
import AuthLayout, { AuthLogo } from './AuthLayout'

// Paid is where a payer lands after paying by card. Their browser has no
// session, so it shows one generic sentence: no business or client details
// and no API call.
export default function Paid() {
  return (
    <AuthLayout panel={false}>
        <div className="auth-form">
          <AuthLogo />
          <div className="auth-branding">
            <h1>Payment received</h1>
            <p className="auth-subtitle">Thank you. You can close this page.</p>
          </div>
        </div>
    </AuthLayout>
  )
}
